

module.exports = __webpack_require__.stylable.create(
    "Divider4114682690",
    {"classes":{"root":"Divider4114682690__root"},"vars":{},"stVars":{"dividerHeight":"1px","dividerBackgroundColor":"black","dividerOpacity":"initial","dividerMarginTop":"initial","dividerMarginBottom":"initial"},"keyframes":{}},
    "",
    1,
    "Divider4114682690",
    null
);
